import { render } from "./PronunciationChart.vue?vue&type=template&id=4d6f0b51"
import script from "./PronunciationChart.vue?vue&type=script&lang=js"
export * from "./PronunciationChart.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__